import { render, staticRenderFns } from "./AppChatBase.vue?vue&type=template&id=1aaae5af&scoped=true&"
import script from "./AppChatBase.vue?vue&type=script&lang=ts&"
export * from "./AppChatBase.vue?vue&type=script&lang=ts&"
import style0 from "./AppChatBase.vue?vue&type=style&index=0&id=1aaae5af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaae5af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VAppBarNavIcon,VBtn,VIcon,VNavigationDrawer})
